module.exports = __webpack_public_path__ + "img/Pedro Gomez.00678014.jpg";